module.exports = __webpack_public_path__ + "24_pvis2.jpg?d00e9d13433a3996cca5b13155d87e22";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/24_pvis2.jpg
// module id = 212
// module chunks = 0